// extracted by mini-css-extract-plugin
module.exports = {"root":"Popover_root__sBFyG","paper":"Popover_paper__OYTXs","backdrop":"Popover_backdrop___4KIN"};